import axios from "axios";
import { baseAddress } from "../../../tools/baseAddress";
import 'grapesjs/dist/css/grapes.min.css';
let addressAddSystem = baseAddress + "add_system";
export const uploadFiles = (csvMagnetic, csvAcoustic, csvSeismic, zip, moreInfo, moreInfoProject, plot_settings) => {
  var formData = new FormData();
  
  // Only append files if they exist
  if (csvMagnetic && csvMagnetic !== "") {
    formData.append("magneticCsv", csvMagnetic);
  }
  if (csvAcoustic && csvAcoustic !== "") {
    formData.append("acousticCsv", csvAcoustic);
  }
  if (csvSeismic && csvSeismic !== "") {
    formData.append("seismicCsv", csvSeismic);
  }
  if (zip && zip !== "") {
    formData.append("archive", zip);
  }
  
  formData.append("token", localStorage.getItem("token"));
  
  if (moreInfo !== null && moreInfo !== undefined) {
    formData.append("moreInfo", moreInfo);
    if (moreInfoProject) {
        formData.append("moreInfoProject", moreInfoProject);
    }
}
  
  if (plot_settings) {
    formData.append("plotSettings", JSON.stringify(plot_settings));
  }
  
  return axios
    .post(addressAddSystem, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => {
      return response
    })
    .catch(err => {
      if (err.response === undefined || err.status === 500 || "500" in err.response)
        return { "data": "Internal server error! Please try again." };
      if (err.response.status === 413)
        return { "data": "The file size can't exceed 150 MB" };
      return err.response
    })
}